module.exports = __webpack_public_path__ + "static/img/noodle2.5dc2ed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noodle/en/noodle2.jpg
// module id = XK7s
// module chunks = 1